import React, { useEffect, useState } from "react";
import Navbar from '../components/Navbar'; // Ensure the path is correct
import ServiceImageAnimation from '../components/ServiceImageAnimation';
import CityDoctors from "../components/CityDoctors";
import Footer from '../components/Footer';
import "./OurServices.css";

const OurServices = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Update the page title
  useEffect(() => {
  document.title = "services - TureMedicine";
  }, []);

  

  const toggleAnswer = (index) => {
    // If the clicked question is already active, collapse it, otherwise show it
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    const benefitItems = document.querySelectorAll('.benefit-item');

    // Create an IntersectionObserver to detect when the element is in the viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add 'show' class when the element enters the viewport
          entry.target.classList.add('show');
        } else {
          // Remove 'show' class when the element exits the viewport
          entry.target.classList.remove('show');
        }
      });
    }, {
      threshold: 0.5 // Trigger when 50% of the element is in the viewport
    });

    // Observe each benefit item
    benefitItems.forEach(item => observer.observe(item));

    // Cleanup the observer
    return () => {
      benefitItems.forEach(item => observer.unobserve(item));
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="services-hero">
        <div className="hero-content">
          <h1>Our Services</h1>
          <p>Empowering healthcare with seamless technology and compassionate care.</p>
        </div>
      </div>

      <div className="highlighted-features">
        <h2>Features We Provide</h2>
        <div className="features-list">
          <div className="feature-box">
            <h3>Search for Doctors Across All Cities</h3>
            <p>Find doctors in every corner of India, not just major cities.</p>
          </div>
          <div className="feature-box">
            <h3>Book Video Consultations with Ease</h3>
            <p>Instantly schedule and attend video consultations with top doctors.</p>
          </div>
          <div className="feature-box">
            <h3>Access Personalized Healthcare Services and History</h3>
            <p>Track your health journey and access your medical records anytime.</p>
          </div>
          <div className="feature-box">
            <h3>Empower Doctors with Profile & Appointment Management</h3>
            <p>Doctors can efficiently manage their profiles and patient appointments.</p>
          </div>
          <div className="feature-box">
            <h3>24/7 Support</h3>
            <p>Access round-the-clock support for all your healthcare queries.</p>
          </div>
        </div>
      </div>
      <CityDoctors />
      <ServiceImageAnimation />
      <h6>Benefits of Using the Platform</h6>
      <div className="benefits-container">
        <div className="benefit-item">
          <h4>Convenience</h4>
          <p>Consult with doctors without traveling.</p>
        </div>
        <div className="benefit-item">
          <h4>Accessibility</h4>
          <p>Reach healthcare in underserved regions.</p>
        </div>
        <div className="benefit-item">
          <h4>Affordability</h4>
          <p>Save time and money by avoiding hospital visits.</p>
        </div>
        <div className="benefit-item">
          <h4>Privacy</h4>
          <p>Secure consultations and data protection.</p>
        </div>
        <div className="benefit-item">
          <h4>Quality Care</h4>
          <p>Access top-rated doctors and specialists.</p>
        </div>
      </div>

      <div className="Testimonials">
        <h4>Testimonials or Success Stories</h4>
        <blockquote>
          <p>&quot;TureMedicine made it so easy to consult with a specialist. I didn’t have to leave my home!&quot; – A happy patient</p>
          <p>&quot;As someone in a remote area, I never thought I’d have access to quality doctors. TureMedicine changed that.&quot; – User from a small town</p>
        </blockquote>
      </div>

      <div className="Pricing">
        <h4>Pricing</h4>
        <p>Our pricing is determined by the doctor’s consultation fee. No hidden charges—just transparent and fair pricing.</p>
      </div>

      <div className="FrequentlyAskedQuestions">
        <h3>Frequently Asked Questions</h3>
        <ul>
          <li>
            <button className="question" onClick={() => toggleAnswer(0)}>
              <strong>Is my data secure?</strong>
            </button>
            <div className={`answer ${activeIndex === 0 ? "show" : ""}`}>
              <p>Yes, your data is encrypted and stored securely.</p>
            </div>
          </li>
          <li>
            <button className="question" onClick={() => toggleAnswer(1)}>
              <strong>Can I consult specialists for specific health issues?</strong>
            </button>
            <div className={`answer ${activeIndex === 1 ? "show" : ""}`}>
              <p>Absolutely! We have specialists across various fields.</p>
            </div>
          </li>
          <li>
            <button className="question" onClick={() => toggleAnswer(2)}>
              <strong>What happens if I miss my appointment?</strong>
            </button>
            <div className={`answer ${activeIndex === 2 ? "show" : ""}`}>
              <p>You can reschedule based on the doctor’s availability.</p>
            </div>
          </li>
          <li>
            <button className="question" onClick={() => toggleAnswer(3)}>
              <strong>How do I get my prescription?</strong>
            </button>
            <div className={`answer ${activeIndex === 3 ? "show" : ""}`}>
              <p>Prescriptions are sent to you digitally after the consultation.</p>
            </div>
          </li>
        </ul>
      </div>
      <Footer /> {/* Footer will be shown on every page */}
    </>
  );
};

export default OurServices;
